import { useTranslation } from "react-i18next";
import clsx from "clsx";

import { ChangeWeekLink } from "./ChangeWeekLink";

import { ChevronIcon, DIRECTION } from "~/components/Icons/ChevronIcon";
import { Text } from "~/components/Text";

export function TimetableEmptyState() {
  const { t } = useTranslation();

  return (
    <div
      className={clsx("flex flex-col items-center justify-center gap-md", "px-md pb-md pt-xs")}
      data-component="TimetableEmptyState"
    >
      <span className="font-medium">
        <Text i18nKey="steps.Timetable.NoPossibilities.Title" />
      </span>

      <div className="flex items-center justify-center gap-md">
        <ChangeWeekLink aria-label={t("steps.Timetable.actions.previous_week")} type="previous">
          <ChevronIcon direction={DIRECTION.LEFT} />

          <span className="text-sm">
            <Text i18nKey="steps.Timetable.actions.previous_week" />
          </span>
        </ChangeWeekLink>

        <ChangeWeekLink aria-label={t("steps.Timetable.actions.next_week")} type="next">
          <span className="text-sm">
            <Text i18nKey="steps.Timetable.actions.next_week" />
          </span>
          <ChevronIcon direction={DIRECTION.RIGHT} />
        </ChangeWeekLink>
      </div>
    </div>
  );
}
